<div class="table-responsive" [class.overflow-hidden]="emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover directory-list-table footable">
        <thead>
            <tr [ngClass]="{'noSort': data?.length < 2}">
                <th></th>
                <th (click)="orderBy('suiteNumber', $event)" class="footable-sorted">
                    Unit<span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="directoryService.buildings.length != 1"
                    (click)="orderBy('building.name', $event)">
                    Building<span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('rentedOut', $event)">
                    Rented Out<span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('occupancyDate', $event)">
                    Occupancy Date<span class="footable-sort-indicator"></span>
                </th>
                <th>Buzz</th>
                <th *ngIf="!directoryService.showDetailedView"
                    (click)="orderBy('proportionateShare', $event)">
                    Prop. Share %<span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!directoryService.showDetailedView">Key Code</th>
                <th *ngIf="!directoryService.showDetailedView">Key Fob</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of data" (click)="toggleCheck(item)">
                <td>
                    <label class="img-checkbox">
                        <input type="checkbox" [ngModel]="item.checked">
                        <label><svg-checked></svg-checked></label>
                    </label>
                </td>
                <td>{{item.suiteNumber}}</td>
                <td *ngIf="directoryService.buildings.length != 1">{{item.buildingName}}</td>
                <td class="with-icon">
                    <i *ngIf="item.rentedOut" class="icon-check"></i>
                    <i *ngIf="!item.rentedOut" class="icon-close"></i>
                </td>
                <td>{{item.occupancyDate | date:'dd.MM.yyyy'}}</td>
                <td>
                    <span *ngFor="let buzz of item.buzzFields; let last = last;">
                        {{buzz.fieldValue}}{{!last ? ', ' : ''}}
                    </span>
                </td>
                <td *ngIf="!directoryService.showDetailedView">{{item.proportionateShare}}</td>
                <td *ngIf="!directoryService.showDetailedView">
                    <span *ngFor="let keyCode of item.keyCodeFields; let last = last;">
                        {{keyCode.fieldValue}}{{!last ? ', ' : ''}}
                    </span>
                </td>
                <td *ngIf="!directoryService.showDetailedView">
                    <span *ngFor="let keyFob of item.keyFobFields; let last = last;">
                        {{keyFob.fieldValue}}{{!last ? ', ' : ''}}
                    </span>
                </td>
            </tr>
            <tr *ngFor="let item of emptyRowService.emptyRow" style="cursor: default;">
                <td><div class="psevdo-checkbox"></div></td>
                <td></td>
                <td *ngIf="directoryService.buildings.length != 1"></td>
                <td></td>
                <td></td>
                <td></td>
                <td *ngIf="!directoryService.showDetailedView"></td>
                <td *ngIf="!directoryService.showDetailedView"></td>
                <td *ngIf="!directoryService.showDetailedView"></td>
            </tr>
        </tbody>
    </table>

    <empty-result-message
            [isEmpty]="!directoryService.directoryData['units'].total"
            [isServiceUnavailable]="directoryService.showServiceUnavailable"
            [isLoading]="directoryService.spinnerShow">
        You have no units listed on the system<br>
        <span *ngIf="directoryService.account.canUpdate('bldn')">
            <a href="javascript://" (click)="directoryService.showModal()" class="mtv-primary-color clickable-text">add an unit</a> now
        </span>
    </empty-result-message>
</div>




// WEBPACK FOOTER //
// /app/src/app/components/directory/list/units-list/units-list.component.html